<script>
import TrainingRequestPage from "@/views/Training/TrainingRequest/TrainingRequestPage.vue";

export default {
    name: "TrainingPlans",
    components: {TrainingRequests: TrainingRequestPage}
}
</script>

<template>
    <training-requests is-plan/>
</template>sessionCandidates